<template>
    <div>
        <!--
        <wysiwyg-editor v-model="conteudo" />-->

        <menu-superior v-if="isAuth" />
        <router-view :key="$route.fullPath"></router-view>
        <rastreamento-modal :id="id" @closed="id = null" ></rastreamento-modal>

    </div>
</template>
<script>
    import { EventBus } from "./utils/event-bus";
    import RastreamentoModal from "./components/modals/RastreamentoModal";
    import WysiwygEditor from './components/WysiwygEditor.vue';

    export default {
        components: {WysiwygEditor, RastreamentoModal},
        data(){
            return {
                id: null
            }
        },
        computed: {
            isAuth () {
                return this.$store.state.auth;
            }
        },
        mounted() {
            EventBus.$on('rastreamento', (id) => {
                this.id = id;
                $("#RastreamentoModal").modal('show');
            });
        }
    }
</script>
<style>

</style>
